import React, { PropsWithChildren } from 'react'
import { Drawer } from '@material-ui/core'
import logo from '../../../assets/logo.svg'
import { useIsDesktop } from '../../../utils/responsive-utils'
import { useNeoWrapperDrawerContext } from './neo-wrapper-drawer.context'
import useNeoWrapperDrawerStyles from './neo-wrapper-drawer.styles'
import { FCB_PRIVACY_STATEMENT, SVB_ECOA_URL } from '../../../utils/urls'
import STATIC_TEXT from '../../../content/common.json'
import { toggleConsentBox } from '../../../utils/onetrust-utils'
import privacyOptionsIcon from '../../../assets/privacy-options.svg'

const NeoWrapperDrawer: React.FC<PropsWithChildren> = ({ children }) => {
    const classes = useNeoWrapperDrawerStyles()
    const isDesktop = useIsDesktop()
    const { isOpen, closeDrawer } = useNeoWrapperDrawerContext()
    const privacyChoiceClicked = (event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault()
        toggleConsentBox()
    }
    return (
        <Drawer
            className={classes.drawer}
            classes={{ paper: classes.drawerPaper }}
            anchor="left"
            variant={isDesktop ? 'permanent' : 'temporary'}
            open={isDesktop ? true : isOpen}
            onClose={isDesktop ? undefined : closeDrawer}
        >
            <header className={classes.toolbar}>
                <img src={logo} className={classes.logo} alt="First Citizens Bank" draggable="false" />
            </header>
            <div className={classes.content}>{children}</div>
            {
                <footer className={classes.footer}>
                    {
                        <a className={classes.footerLink} rel="noopener noreferrer" target="_blank" href={FCB_PRIVACY_STATEMENT}>
                            {STATIC_TEXT.footer.privacyPolicy}
                        </a>
                    }
                    {
                        <a className={classes.footerLink} rel="noopener noreferrer" href="#" onClick={privacyChoiceClicked}>
                            {STATIC_TEXT.footer.privacyChoices}
                            <img className={classes.footerPrivacyChoicesImage} src={privacyOptionsIcon} />
                        </a>
                    }
                    {
                        <a className={classes.footerLink} rel="noopener noreferrer" target="_blank" href={SVB_ECOA_URL}>
                            {STATIC_TEXT.footer.ECOADisclosure}
                        </a>
                    }
                </footer>
            }
        </Drawer>
    )
}

export default NeoWrapperDrawer
